// Android, iPhone, iPad
export function isMobile(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false; // Default to false on server-side
  }

  const ua = navigator.userAgent;
  const touch = navigator.maxTouchPoints || 0;

  // NOTE: From iOS 13, platform is Macintosh even on iPad
  return /iPhone|iPad|iPod|Android/i.test(ua) || (/Macintosh/.test(ua) && touch > 1);
}

export function isAndroid(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false; // Default to false on server-side
  }

  const ua = navigator.userAgent;
  return /Android/i.test(ua);
}

export function isIOS(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false; // Default to false on server-side
  }

  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua);
}
